import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  selectOrganization,
  hideDeleteCourseModalMethod,
  publishOrganization,
} from '../actions'
import ConnectedCoursesTable from './ConnectedCoursesTable'
import RemoveCourseModal from './RemoveCourseModal'

class Organization extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      addNew: false,
      showSecret: false,
      showToken: false,
    }
  }

  deselectOrg = () => {
    this.props.selectOrganization(null)
  }

  publishOrg = () => {
    this.props.publishOrganization({ id: this.props.orgId })
  }

  toggleNew = () => {
    this.setState(prevState => ({
      addNew: !prevState.addNew,
    }))
  }

  toggleHidden = keyName => {
    this.setState(prevState => ({
      [keyName]: !prevState[keyName],
    }))
  }

  render() {
    let contactsMap = this.props.myeducatorUsers.reduce((map, user) => {
      map[user.id] = user.email
      return map
    }, {})

    let ocnUpdatedIcon =
      this.props.ocnUpdated === 'true' ? (
        <span className="label label-success">Published</span>
      ) : (
        <span className="label label-danger">Out of Date</span>
      )

    let publishControl =
      this.props.ocnUpdated === 'true' ? (
        <span className="label label-success">Published</span>
      ) : (
        <button className="btn btn-success" onClick={this.publishOrg}>
          Publish
        </button>
      )

    let addButton = this.state.addNew ? (
      <button className="btn btn-danger" onClick={this.toggleNew}>
        <i className="fa fa-window-close" /> Cancel
      </button>
    ) : (
      <button className="btn btn-primary" onClick={this.toggleNew}>
        <i className="fa fa-plus" /> Add New
      </button>
    )

    let secret = this.state.showSecret
      ? this.props.clientSecret
      : '*****************'
    let secretControl = this.state.showSecret ? (
      <a
        onClick={() => this.toggleHidden('showSecret')}
        className="btn btn-xs btn-primary"
      >
        Hide
      </a>
    ) : (
      <a
        onClick={() => this.toggleHidden('showSecret')}
        className="btn btn-xs btn-primary"
      >
        Show
      </a>
    )

    let token = this.state.showToken
      ? this.props.oauthToken
      : '*****************'
    let tokenControl = this.state.showToken ? (
      <a
        onClick={() => this.toggleHidden('showToken')}
        className="btn btn-xs btn-primary"
      >
        Hide
      </a>
    ) : (
      <a
        onClick={() => this.toggleHidden('showToken')}
        className="btn btn-xs btn-primary"
      >
        Show
      </a>
    )

    let message =
      this.props.hasBadData === 'true' ? (
        <div className="alert alert-danger">
          The API returned a bad status code.
        </div>
      ) : null

    return (
      <div>
        {message}
        <div>
          <button className="btn btn-warning" onClick={this.deselectOrg}>
            Go Back
          </button>
          <div style={{ float: 'right' }}>{publishControl}</div>
        </div>
        <h2>{this.props.orgName}</h2>
        <table>
          <tbody>
            <tr>
              <td>Contact:</td>
              <td>{contactsMap[this.props.contact]}</td>
            </tr>
            <tr>
              <td>Base URL:</td>
              <td>{this.props.baseUrl}</td>
            </tr>
            <tr>
              <td>Provider ID:</td>
              <td>{this.props.providerId}</td>
            </tr>
            <tr>
              <td>SF User ID:</td>
              <td>{this.props.sfUserId}</td>
            </tr>
            <tr>
              <td>Client ID:</td>
              <td>{this.props.clientId}</td>
            </tr>
            <tr>
              <td>Client Secret:</td>
              <td>
                {secret} {secretControl}
              </td>
            </tr>
            <tr>
              <td>OAuth Token:</td>
              <td>
                {token} {tokenControl}
              </td>
            </tr>
            <tr>
              <td>OCN Updated:</td>
              <td>{ocnUpdatedIcon}</td>
            </tr>
          </tbody>
        </table>
        <RemoveCourseModal
          show={this.props.showRemoveCourseModal}
          close={this.props.hideDeleteCourseModal}
        />
        <div>
          <div className="mt-2">{addButton}</div>
          <ConnectedCoursesTable
            addNew={this.state.addNew}
            toggleFunc={this.toggleNew}
          />
        </div>
      </div>
    )
  }
}

Organization.propTypes = {
  orgId: PropTypes.string,
  contact: PropTypes.string,
  orgName: PropTypes.string,
  providerId: PropTypes.string,
  sfUserId: PropTypes.string,
  clientId: PropTypes.string,
  clientSecret: PropTypes.string,
  baseUrl: PropTypes.string,
  oauthToken: PropTypes.string,
  ocnUpdated: PropTypes.string,
  hasBadData: PropTypes.string,
  myeducatorUsers: PropTypes.array,
  showRemoveCourseModal: PropTypes.bool,
  selectOrganization: PropTypes.func,
  hideDeleteCourseModal: PropTypes.func,
  publishOrganization: PropTypes.func,
}

const mapStateToProps = state => {
  return {
    myeducatorUsers: state.myeducatorUsers,
    showRemoveCourseModal: state.showRemoveCourseModal,
  }
}
const mapDispatchToProps = dispatch => {
  return {
    selectOrganization: selectedOrgId => {
      dispatch(selectOrganization(selectedOrgId))
    },
    hideDeleteCourseModal: () => {
      dispatch(hideDeleteCourseModalMethod())
    },
    publishOrganization: orgData => {
      dispatch(publishOrganization(orgData))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Organization)
